import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { OptionProps } from 'react-select';

type OptionLayoutPlaceOption = {
  label: string;
  value?: string;
  icon?: IconProp;
  flag?: string;
  description?: string;
};

type OptionLayoutPlaceProps = OptionProps<OptionLayoutPlaceOption, false>;

const OptionLayoutPlace = (props: OptionLayoutPlaceProps) => {
  const { innerProps, innerRef, isDisabled, isSelected } = props;
  const tooltipText = isDisabled ? props.data?.description : null;
  return (
    <>
      <style>{`
          .customized-searchbox-option:hover{
            background-color:var(--falcon-gray-link-hover-300) !important;
          }
          .customized-searchbox-option{
            background-color:var(--falcon-tertiary-bg) !important;
          }
          .customized-searchbox-option.is-disabled:hover{
            background-color:var(--falcon-tertiary-bg) !important;
          }
    
          `}</style>
      <div
        ref={innerRef}
        {...innerProps}
        aria-disabled={isDisabled || undefined}
        style={{
          backgroundColor: isSelected
            ? 'var(--falcon-gray-link-hover-100)'
            : 'var(--falcon-dropdown-bg-global)',
          opacity: isDisabled ? 0.6 : 1,
          cursor: isDisabled ? 'not-allowed' : 'pointer',
          pointerEvents: 'auto'
        }}
        className={`p-2 border border-1 customized-searchbox-option${
          isDisabled ? ' is-disabled' : ' cursor-pointer'
        }`}
      >
        <div className="fs--1 text-900 d-flex align-items-center gap-2">
          {props.data?.icon ? (
            <FontAwesomeIcon icon={props.data.icon} title={props.data.label} />
          ) : (
            props.data?.flag && (
              <img
                src={props.data.flag}
                alt="country icon"
                width="20px"
                loading="lazy"
                height="11px"
              />
            )
          )}
          {props.data.label}{' '}
          {tooltipText ? (
            <OverlayTrigger
              placement="left"
              overlay={
                <Tooltip style={{ position: 'fixed', zIndex: 9999 }}>
                  {tooltipText}
                </Tooltip>
              }
            >
              <span
                className="d-inline-flex align-items-center"
                onClick={event => event.stopPropagation()}
                onMouseDown={event => event.stopPropagation()}
              >
                <FontAwesomeIcon
                  icon="info-circle"
                  className="text-warning"
                />
              </span>
            </OverlayTrigger>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default OptionLayoutPlace;
